// KEATS PDP section positioner — May 27 2026 v2
// Normalizes order of right-column blocks on multi-variant PDPs across browsers
// (Chrome and Safari render Shopify sections in different default orders).
//
// Target order on every PDP:
//   ... → QUANTITY (.product-quantity-wrapper) → CHOOSE YOUR PLAN (.keats-variant-picker) → ATC (.pdp-action-container)
//
// Idempotent — each moved block gets data-keats-position-moved attribute.
(function () {
  'use strict';

  var MOVED_FLAG = 'data-keats-position-moved';

  function findATCContainer() {
    var atc = Array.from(document.querySelectorAll('button')).find(function (b) {
      return (b.textContent || '').toLowerCase().indexOf('add to cart') !== -1
        && b.getBoundingClientRect().height > 0;
    });
    if (!atc) return null;
    return atc.closest('.pdp-action-container') || atc.parentElement;
  }

  function findPickerBlock() {
    var picker = document.querySelector('.keats-variant-picker');
    if (!picker) return null;
    return picker.closest('.product_custom_liquid')
      || picker.closest('.shopify-section')
      || picker.parentElement;
  }

  function findQtyBlock() {
    var qty = document.querySelector('.product-quantity-wrapper, .yv-product-quantity');
    if (!qty) return null;
    return qty.closest('.product-quantity-wrapper')
      || qty.closest('.shopify-section')
      || qty;
  }

  function moveBefore(target, anchor) {
    if (!target || !anchor) return false;
    if (target === anchor) return false;
    // Skip if already in correct order
    var tRect = target.getBoundingClientRect();
    var aRect = anchor.getBoundingClientRect();
    if (tRect.top < aRect.top && tRect.top > 0) return true; // already above
    anchor.parentNode.insertBefore(target, anchor);
    target.setAttribute(MOVED_FLAG, '1');
    return true;
  }

  function normalize() {
    var atcContainer = findATCContainer();
    if (!atcContainer) return false;
    var picker = findPickerBlock();
    var qty = findQtyBlock();

    // Order: QUANTITY → PICKER → ATC
    // 1. Move picker before ATC (if not already)
    if (picker) moveBefore(picker, atcContainer);
    // 2. Move QUANTITY before picker (if picker exists) OR before ATC
    if (qty) {
      var anchor = picker || atcContainer;
      moveBefore(qty, anchor);
    }
    return true;
  }

  var attempts = 0;
  var pollId = setInterval(function () {
    attempts++;
    if (normalize() || attempts > 60) clearInterval(pollId);
  }, 200);
})();
